exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fc-event-container a {\n  width: 10px !important;\n  background: var(--db--arrow-down-border);\n  float:left;\n}\n", ""]);

// exports
